import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StructuredDataService {
    constructor(@Inject(DOCUMENT) private readonly doc: Document) {}

    setJsonLd(key: string, payload: unknown): void {
        this.removeJsonLd(key);
        const script = this.doc.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-managed', key);
        script.text = JSON.stringify(payload);
        this.doc.head.appendChild(script);
    }

    removeJsonLd(key: string): void {
        const selector = `script[type="application/ld+json"][data-seo-managed="${key}"]`;
        const script = this.doc.head.querySelector(selector);
        if (script?.parentNode) script.parentNode.removeChild(script);
    }
}
